import { FETCH_CUSTOM_PAGE_URL } from './const';
import { CustomPagePath, CustomPageWidgets } from './types';
import { GET } from '@packages/dataFetch';

export async function fetchCustomPageData(path: CustomPagePath) {
	const response = await GET<CustomPageWidgets>(FETCH_CUSTOM_PAGE_URL, {
		params: { path },
		pageContentRequestHeader: true,
	});

	return response.data;
}
